import React from 'react';
import PropTypes from 'prop-types';
import {SidebarBurgerOpen, SidebarInfo} from '../../components/SvgComponents/SvgComponents';
import {Link} from 'react-router-dom';
import {buildRoute, ROUTES} from '../../configs/routes';
import LanguageSelect from '../../components/LanguageSelect/LanguageSelect';
import {t} from '../../services/i18nHandler';
import URL_MAP from '../../constants/urls';

const navMenu = [
  {
    link: ROUTES.HOW_IT_WORK.route,
    text: 'nav.howItWork',
  },
  {
    link: ROUTES.ABOUT_COMPANY.route,
    text: 'nav.aboutCompany',
  },
  {
    link: buildRoute(URL_MAP.PLANS),
    text: 'nav.services',
  },
  {

    link: buildRoute(URL_MAP.YOU_CANDIDATE),
    text: 'nav.forJobSeekers',

  },
  {
    link: buildRoute(URL_MAP.YOU_EMPLOYER),
    text: 'nav.forEmployers',
  },
  {
    link: buildRoute(URL_MAP.YOU_AGENCY),
    text: 'nav.forAgency',
  },
  {
    link: ROUTES.NEWS.route,
    text: 'nav.news',
  },
];

function LandingPageHeader({language, loggedIn}) {
  return (
    <div className="landing-header d-flex justify-content-between">
      <button className="show-mobile burger-button" type="button" onClick={() => console.log('toggle menu')}>
        <SidebarBurgerOpen />
      </button>
      <img className="logo" src={`../../assets/images/landing/logo-mnj-header-${language}.svg`} alt="My New Job" />
      <button className="show-mobile header-info-btn" type="button" onClick={() => console.log('info')}>
        <SidebarInfo />
      </button>
      <div className="landing-header_menu">
        {navMenu.map((item, index) => (
          <div key={index} className="landing-header_menu_item">
            <Link to={item.link}>{t(item.text)}</Link>
          </div>
        ))}
      </div>
      <div className="landing-header--authorization d-flex justify-center">
        <Link to={ROUTES.LOGIN.route} className="btn btn-link">{t('buttons.logIn')}</Link>
        {!loggedIn && (
          <Link to={ROUTES.REGISTRATION.route} className="btn btn-base">{t('buttons.register')}</Link>
        )}
        <LanguageSelect />
      </div>
    </div>
  );
}

LandingPageHeader.defaultProps = {
  language: 'ru',
  loggedIn: false,
};

LandingPageHeader.propTypes = {
  language: PropTypes.string,
  loggedIn: PropTypes.bool,
};

export default LandingPageHeader;
